import React from 'react';
import { t } from '../../lib/i18n';

const BAR_COUNT = 6;

interface AudioMeterProps {
  /** 0-100 arası anlık seviye. */
  level: number;
  isActive: boolean;
  icon: React.ReactNode;
  /** Erişilebilirlik ve ipucu metni — hangi kaynağın ölçüldüğü. */
  label: string;
  isDarkMode: boolean;
}

/**
 * Tek bir ses kaynağının seviye göstergesi. Kayıt ekranında iki tane var:
 * mikrofon (sen) ve sistem sesi (karşı taraf). İkisi ayrı ayrı gösteriliyor
 * çünkü en sık yaşanan sorun "karşı tarafın sesi kaydedilmiyor" oluyor ve
 * tek bir karışık çubuk bunu göstermiyordu.
 */
export const AudioMeter: React.FC<AudioMeterProps> = ({
  level,
  isActive,
  icon,
  label,
  isDarkMode,
}) => (
  <div
    title={label}
    aria-label={`${label}: ${isActive ? t(`%${Math.round(level)}`, `${Math.round(level)}%`) : t('kapalı', 'off')}`}
    className={`flex items-center gap-1.5 px-2 py-1.5 rounded-lg border ${
      isDarkMode ? 'border-[#3B3B3F] bg-[#19191C]' : 'border-neutral-200 bg-neutral-50'
    }`}
  >
    <span className={isActive ? 'text-[#46CBE2]' : 'text-neutral-500'}>{icon}</span>
    <div className="flex items-end gap-[2px] h-3.5" aria-hidden="true">
      {Array.from({ length: BAR_COUNT }).map((_, index) => {
        // Soldaki çubuklar önce dolsun: her çubuk seviyeden kendi payını düşer.
        const height = isActive
          ? Math.min(100, Math.max(18, level - index * 11))
          : 18;
        return (
          <span
            key={index}
            style={{ height: `${height}%` }}
            className={`w-[3px] rounded-full transition-[height] duration-75 ${
              isActive && level > index * 11
                ? 'bg-[#46CBE2]'
                : isDarkMode
                  ? 'bg-neutral-600'
                  : 'bg-neutral-300'
            }`}
          />
        );
      })}
    </div>
  </div>
);
